export default __webpack_public_path__ + "static/media/mirolyub_xl.54d88688.jpg";